import { WidthContainer } from '@pata-app/ui-document';

import React from 'react';

import SectionContainer from '../../../../components/sectionContainer/sectionContainer';
import { FEATURES_CONFIG } from '../../businessFeatures.config';
import { FeatureSection } from './featureSection';

export function FeaturesSection() {
  return FEATURES_CONFIG.map((featureSection, index) => (
    <WidthContainer>
      <SectionContainer id={featureSection.id}>
        <FeatureSection key={featureSection.id} featureSection={featureSection} rightAligned={index % 2 === 0} />
      </SectionContainer>
    </WidthContainer>
  ));
}
